import styled from 'styled-components';
import { size } from 'polished';
import SimpleBar from 'simplebar-react';
import { Paragraph, ParagraphId } from '../../atoms/Paragraph/Paragraph';
import { Button } from '../../molecules/Button/Button';
import { Checkbox } from '../../molecules/Checkbox/Checkbox';
import { pseudo } from '../../../styles/helpers/pseudo';
import { MediaQuery } from '../../../styles/mediaQuery';
import { respondTo } from '../../../styles/helpers/respondTo';
import { zIndex } from '../../../styles/zIndex';

export const StyledMapNavigation = styled.div`
  position: relative;
  background: ${({ theme }) => theme.color.white};
  box-shadow: 0 0.25rem 1.25rem rgba(48, 76, 178, 0.2);
  z-index: ${zIndex('overlay')};

  @media ${respondTo(MediaQuery.Large)} {
    width: 26.25rem;
    min-width: 26.25rem;
    height: 100vh;
  }
`;

export const StyledScrollWrapper = styled(SimpleBar)<{ $openSelector: boolean }>`
  padding: 1.875rem 1.25rem 6.875rem;
  width: 100%;

  .simplebar-content {
    display: flex;
    flex-direction: column;
    min-height: 100%;

    &::before,
    &::after {
      content: none;
    }
  }

  ${({ $openSelector }) =>
    !$openSelector &&
    `
    .simplebar-content-wrapper {
      mask-image: linear-gradient(to bottom, black calc(100% - 7.1875rem), transparent calc(100% - 5rem));
    }

    @media ${respondTo(MediaQuery.Large)} {
      .simplebar-content-wrapper {
        mask-image: linear-gradient(to bottom, black calc(100% - 8.4375rem), transparent calc(100% - 6.25rem));
      }
    }
  `}

  ${({ $openSelector }) =>
    $openSelector &&
    `
    z-index: ${zIndex('overlay')};
  `}

  @media ${respondTo(MediaQuery.Large)} {
    padding: 3.125rem 1.875rem 7.5rem;
    max-height: 100vh;
    height: 100%;
  }

  @media ${respondTo(MediaQuery.XLarge)} {
  }
`;

export const StyledIntroText = styled(Paragraph)`
  margin: 0.625rem 0 1.5625rem;
`;

export const StyledSubmitButton = styled(Button)`
  border-radius: ${({ theme }) => theme.defaultCssProps.borderRadius.xSmall};
  left: 0.3125rem;
  width: calc(100% - 0.625rem);
  margin-top: 1.875rem;
`;

export const StyledFlightSummary = styled.div`
  display: flex;
  padding: 1.5rem 1rem;
  margin: 2.5rem 0 0.9375rem;
  background: ${({ theme }) => theme.color.white};
  border: 1px solid ${({ theme }) => theme.color.lighterGrey};
  border-radius: ${({ theme }) => theme.defaultCssProps.borderRadius.normal};
`;

export const StyledFlightTypeIndicator = styled(Paragraph)<{ $flightType: string }>`
  position: relative;
  display: flex;
  align-items: flex-end;
  margin-right: 1.0625rem;
  color: ${({ theme }) => theme.color.blue};

  &::before,
  &::after {
    ${pseudo()};
    top: 0.3125rem;
    left: 40%;
    transform: translateX(-50%);
  }

  &::before {
    ${size('0.4375rem')};
    border-radius: 50%;
    background-color: ${({ theme }) => theme.color.blue};
  }

  &::after {
    ${size('calc(100% - 1.5625rem)', '1px')};
    background: ${({ theme }) => theme.color.blue};
  }

  svg {
    ${size('1.0625rem')};
  }

  ${({ $flightType, theme }) =>
    $flightType === 'connected' &&
    `
    &::after {
      background: transparent;
      background-image: linear-gradient(${theme.color.blue} 60%, rgba(255,255,255,0) 0%);
      background-position: right;
      background-size: 1px 8px;
      background-repeat: repeat-y;
    }
  `}
`;

export const StyledFlightLocation = styled(Paragraph)`
  color: ${({ theme }) => theme.color.black};

  span {
    display: block;
    margin-top: 0.3125rem;
    color: ${({ theme }) => theme.color.grey};
  }
`;

export const StyledFlightType = styled(ParagraphId)`
  margin: 0.875rem 0;
  color: ${({ theme }) => theme.color.blue};
`;

export const StyledAdditionalInformation = styled.div`
  margin-top: 0.625rem;
  color: ${({ theme }) => theme.color.grey};
  line-height: 1.428;

  strong {
    display: block;
  }

  a {
    color: ${({ theme }) => theme.color.blue};
    text-decoration: underline;
  }

  img {
    display: block;
    margin: 0.9375rem 0;
  }
`;

export const StyledCheckbox = styled(Checkbox)`
  margin-top: 1.25rem;
`;
